"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuButton = exports.menuItem = void 0;

var _react = require("@emotion/react");

var _core = require("@material-ui/core");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  min-width: 180px;\n  min-height: 48px;\n  font-size: 15px;\n  line-height: 21px;\n  padding: 0 16px;\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var menuItem = function menuItem(highlight) {
  return function (theme) {
    return (0, _react.css)(_templateObject(), theme.colors.neutral[50], highlight && "::after {\n    content: ' ';\n    border-radius: ".concat(theme.radii.lg, ";\n    width: 8px;\n    height: 8px;\n    background-color: ").concat(theme.colors.primary.lighter, ";\n  }"));
  };
}; // = (scrollable: boolean) => (): Interpolation => css


exports.menuItem = menuItem;

var menuButton = function menuButton(dense, isMenuOpen) {
  return function (theme) {
    return (0, _react.css)(_templateObject2(), isMenuOpen ? "0 0 0 ".concat(dense ? '3px' : '4px', ' ', "\n").concat((0, _core.lighten)(theme.colors.accent, 0.7), " !important;") : "none");
  };
};

exports.menuButton = menuButton;